import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './article.scss';
import { svg_default_file_app } from '../../../core/hooks/assetsConstants';
import { useWordService, useWordCategoryService } from '../../../core/hooks/services/word.service';
import SearchGeneral from '../../../components/content/searchs/search_general/SearchGeneral';
import YouTubeVideo from '../../../components/content/videos/video_youtube/YouTubeVideo';
import CardItemCategory from '../../../components/content/cards/card_item_category/CardItemCategory';

export default function Article({ setPageTitle }: any) {
    const { slug, id } = useParams<{ slug: string; id?: string }>();
    const [article, setArticle] = useState<any | null>(null);
    const navigate = useNavigate();

    // Llamada al servicio de palabras
    const { content, loading: serviceLoading, error } = useWordService();
    const [dataWord, setDataWord] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const { content: contentWordCategory, loading: loadingWordCategory, error: errorWordCategory } = useWordCategoryService(0);
    const [dataWordCategory, setDataWordCategory] = useState<any[]>([]);

    useEffect(() => {
        // Función para obtener los datos de las palabras
        const fetchData = async () => {
            try {
                const result = await content();
                if (result) {
                    setDataWord(result.data.word);
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching word data:", error);
                setLoading(false);
            }
        };

        // Función para obtener los datos de la palabra de categorias
        const fetchWordCategoryData = async () => {
            try {
                const result = await contentWordCategory();

                if (result && result.data && result.data.wordByCategory) {
                    // Guarda los datos de la palabra en el estado
                    setDataWordCategory(result.data.wordByCategory);
                } else {
                    setDataWordCategory([]);
                }
            } catch (error) {
                console.error("Error fetching word data:", error);
                setDataWordCategory([]);
            }
        };

        fetchData();
        fetchWordCategoryData();
    }, []);

    useEffect(() => {
        if (dataWord.length > 0 && slug) {
            const parsedId = id ? Number(id) : null;
            const foundArticle = dataWord.find((item: any) =>
                item.slug_word === slug && (parsedId === null || item.id_word === parsedId)
            );

            if (foundArticle) {
                setArticle(foundArticle);
                setPageTitle(foundArticle.category.name_category);
                document.title = `${foundArticle.category.name_category} | SeñaTech`;
            } else {
                navigate('/404', { replace: true });
            }
        }
    }, [dataWord, slug, id, navigate, setPageTitle]);


    if (loading || serviceLoading) return <div>Cargando...</div>;
    if (error) return <div>Error al cargar los datos</div>;

    return (
        <section className="page content_article">
            {article && (
                <>
                    <div className='title_content'>
                        <h1 className='title'>Base de conocimiento</h1>
                        <div className='search'>
                            <SearchGeneral data={dataWord} showInitialResults={true} />
                        </div>
                    </div>

                    <div className='info_content'>

                        <div className='media_content'>
                            <h1 className='title'><img src={svg_default_file_app} width={30} alt="file" /> {article.name_word}</h1>

                            {article.definition_word && <p className='description'>{article.definition_word}</p>}

                            <YouTubeVideo url={article.gallery.video_gallery} />

                            <div className='gallery'>
                                <div>
                                    <h1 className='title'>{article.gallery.title_gallery}</h1>
                                    {article.gallery.description_gallery && <p className='description'>{article.gallery.description_gallery}</p>}
                                    <img className='image' src={article.gallery.image_gallery} alt={article.gallery.title_gallery} />
                                </div>
                            </div>

                        </div>

                        <div className='category_content'>
                            <CardItemCategory data={dataWordCategory} />
                        </div>
                    </div>
                </>
            )}
        </section>
    );
}
